import { FC } from 'react';
import classNames from 'classnames';
import WorkingHoursOrderTypeOption from '../WorkingHoursOrderTypeOption/WorkingHoursOrderTypeOption';
import { localeStore } from 'src/mobx/localesStore';
import { WORKING_HOURS_ORDER_TYPE } from 'src/view/screens/BranchesManagementScreen/screens/BranchEditScreen/types/branchEdit';
import { IPosIntRestriction } from '~/types/integrations';
import IntegrationManager from '~/view/components/IntegrationManager/IntegrationManager';
import { TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';

interface IProps {
  selectedOrderTypes: WORKING_HOURS_ORDER_TYPE[];
  posIntRestriction: IPosIntRestriction;
  error: boolean;
  disabled: boolean | undefined;
  onSelect: (orderType: WORKING_HOURS_ORDER_TYPE) => void;
}

const WorkingHoursOrderTypes: FC<IProps> = ({ selectedOrderTypes, posIntRestriction, error, disabled, onSelect }): JSX.Element => {
  const checkboxOptions = [
    { id: WORKING_HOURS_ORDER_TYPE.DELIVERY, label: 'delivery' },
    { id: WORKING_HOURS_ORDER_TYPE.PICKUP, label: `${localeStore.t('Pickup')}/${localeStore.t('curbside')}/${localeStore.t('dinein')}` },
  ];

  return (
    <div className="d-flex flex-column mt-5">
      <p className="family-semibold text-size-18 required">{localeStore.t('order_type')}</p>
      <div className={classNames('d-flex flex-column gap-20 mt-4', { disabled })}>
        {checkboxOptions.map((option) => {
          const status = selectedOrderTypes.includes(option.id);

          return (
            <IntegrationManager
              setting={posIntRestriction.access}
              withTooltip
              tooltipOptions={{ show: posIntRestriction.shouldDisable, minWidth: 355, position: TOOLTIP_POSITION.PORTAL }}
            >
              <WorkingHoursOrderTypeOption key={option.id} id={option.id} status={status} error={error} label={option.label} onSelect={onSelect} />
            </IntegrationManager>
          );
        })}
      </div>
      {error && <p className="family-regular text-size-14 color-red mt-2">{localeStore.t('atleast_one_order_type')}</p>}
    </div>
  );
};

export default WorkingHoursOrderTypes;
